import {Modal} from "bootstrap";

export default function (html) {
	Array.from(html.querySelectorAll('.modal[data-show="true"]')).forEach((el) => {
		new Modal(el, {}).show()
	})
}
